import { Sc3FailedMessagesListSearchCriteria } from '../../models';

export class Sc3FailedMessagesListLoad {
  public static readonly type = '[Sc3FailedMessagesList] Load';
  constructor(public payload: Sc3FailedMessagesListSearchCriteria) {}
}

export class Sc3FailedMessagesListInitialState {
  public static readonly type = '[Sc3FailedMessagesList] Set initial state';
}
